/* eslint-disable no-shadow */
import { ReactNode } from 'react';

export enum ROUTES {
  ASR_FORM = '/asr-form',
  COSMETIC_DISCLAIMER = '/cosmetic-disclaimer',
  COSMETIC_IMAGES = '/cosmetic-images',
  COSMETIC_SUCCESS = '/cosmetic-success',
  MECHANIC_SUCCESS = '/mechanic-success',
  VIEW_ISSUE = '/view-issue',
  LOADING = '/loading',
}

export type RouteItem = {
  path: ROUTES;
  component: ReactNode;
};

export enum ERRORS {
  DEFAULT = 'Something went wrong, please try again later',
}
